import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
});

function Apps(props) {
    const classes = useStyles();

    return (
        <h1>Apps settings</h1>
    );
}

export default Apps